'use client';

var _Clock;
import Clock from '@crehana/compass.icons.outline/Clock';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../Select";
import { hourArr, minuteArr } from "./constants";
import { getHourData } from "./utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var TimePicker = function TimePicker(_ref) {
  var className = _ref.className,
    value = _ref.value,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'am/pm' : _ref$mode,
    placeholder = _ref.placeholder,
    onTimeChange = _ref.onTimeChange;
  var renderHours = function renderHours() {
    var hoursJsx = [];
    hourArr.forEach(function (hour) {
      minuteArr.forEach(function (minute) {
        var _getHourData = getHourData(hour, mode),
          hourStr = _getHourData.hourStr,
          suffix = _getHourData.suffix;
        var label = "".concat(hourStr, ":").concat(minute);
        hoursJsx.push({
          label: label,
          suffix: suffix
        });
      });
    });
    return hoursJsx;
  };
  var renderSelectItems = function renderSelectItems() {
    return renderHours().map(function (hour) {
      var optValue = "".concat(hour.label).concat(hour.suffix);
      return /*#__PURE__*/_jsxs(SelectItem, {
        value: optValue,
        children: [/*#__PURE__*/_jsx("span", {
          className: "tw-inline-block tw-w-4.4",
          children: hour.label
        }), /*#__PURE__*/_jsx("span", {
          children: hour.suffix
        })]
      }, optValue);
    });
  };
  return /*#__PURE__*/_jsxs(Select, {
    value: value,
    onValueChange: onTimeChange,
    children: [/*#__PURE__*/_jsx(SelectTrigger, {
      className: className,
      renderIcon: function renderIcon() {
        return _Clock || (_Clock = /*#__PURE__*/_jsx(Clock, {
          className: "tw-text-neutral-light-600",
          size: 24
        }));
      },
      children: /*#__PURE__*/_jsx(SelectValue, {
        placeholder: /*#__PURE__*/_jsx("span", {
          className: "tw-text-neutral-light-700",
          children: placeholder
        })
      })
    }), /*#__PURE__*/_jsx(SelectContent, {
      children: renderSelectItems()
    })]
  });
};